<!--
Non-bootstrap version of Confirm.vue - intended to be a drop-in replacement.
bootstrap modals are breaking with $.... modal is not a function :-(

@author cm359n
-->
<template>
  <div>
    <NewModalPopup v-if="showConfirm" id="confirm" :title="props.header" displayAt="top">
      <p>{{ msg }}</p>
      <div class="w-100">
        <div class="btn-group w-100" role="group" aria-label="confirm buttons">
          <button type="button" :class="'btn ' + mergedOptionOne.style" style="margin-right:2px;width:50%;"
            @click="doOptionOneCallback()">{{ mergedOptionOne.text }}</button>
          <button type="button" :class="'btn ' + mergedOptionTwo.style" style="margin-left:2px;width:50%;"
            @click="doOptionTwoCallback()">{{ mergedOptionTwo.text }}</button>
        </div>
      </div>
    </NewModalPopup>
  </div>
</template>

<script setup>
//Utilities
import { ref, defineExpose, computed } from 'vue'

//Components
import NewModalPopup from '@/components/NewModalPopup.vue'

//Data
const showConfirm = ref(false)

const allowedStyles = ['primary', 'secondary', 'outline']

//Props
const props = defineProps({
  msg: String,
  header: String,
  optionOne: {
    type: Object,
    default: () => ({
      text: 'OK',
      style: 'primary'
    })
  },
  optionTwo: {
    type: Object,
    default: () => ({
      text: 'Cancel',
      style: 'secondary'
    })
  }
})

// This is basically for when props are omitted
const mergedOptionOne = computed(() => ({
  text: props.optionOne?.text ?? 'OK',
  style: allowedStyles.includes(props.optionOne?.style) ? props.optionOne.style : 'primary'
}))

const mergedOptionTwo = computed(() => ({
  text: props.optionTwo?.text ?? 'Cancel',
  style: allowedStyles.includes(props.optionTwo?.style) ? props.optionTwo.style : 'secondary'
}))


//Submit and cancel functions that will have their function replaced by the parameters of the 'show' function
let onOptionOneCallback = () => {}
let onOptionTwoCallback = () => {}

// we should close this thing when ok/cancel are called
// we don't get that for free with this non-bootstrap version
function doOptionOneCallback () {
  showConfirm.value = false
  onOptionOneCallback()
}

function doOptionTwoCallback () {
  showConfirm.value = false
  onOptionTwoCallback()
}


 // Used by container components to show the dialogue.
// As this is a global component, if callbacks are not defined they revert to noop.
const show = (optionOneCallback = defaultOptionOneCallback, optionTwoCallback = defaultOptionTwoCallback) => {
  console.log()
  onOptionOneCallback = optionOneCallback
  onOptionTwoCallback = optionTwoCallback
  showConfirm.value = true
}

defineExpose({
  show
})

// Default callback function called when the OK button is clicked.
// Container components can override this.
function defaultOptionOneCallback () {
  noop()
}
// Default callback function called when the Cancel button is clicked.
// Container components can override this.
function defaultOptionTwoCallback () {
  noop()
}
// No op function for default/unspecified callbacks.
function noop () {
  console.log('noop')
}

</script>

<style scoped>
.primary {
  background-color: var(--uog-dark-blue)!important;
}

.secondary {
  background-color: var(--uog-blue-10) !important;
}

.outline {
  border-color: #000 !important;
  background-color: #fff !important;
}

</style>


